import React from "react";
import { FooterButton, FooterButtonGroup } from "../footer";

export const FPSMeterButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <FooterButtonGroup>
      <FooterButton tooltip={"FPSMeter"} onClick={onClick} disabled={false} testid="fps-meter-button">
        <svg width="45px" height="31px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="6" cy="12" r="9" stroke="black" fill="none" />

          <line x1="6" y1="3" x2="6" y2="5" stroke="black" />
          <line x1="10.95" y1="5.05" x2="9.7" y2="6.3" stroke="black" />
          <line x1="13.9" y1="10" x2="12" y2="10" stroke="black" />
          <line x1="13.9" y1="14" x2="12" y2="14" stroke="black" />
          <line x1="10.95" y1="18.95" x2="9.7" y2="17.7" stroke="black" />
          <line x1="6" y1="21" x2="6" y2="19" stroke="black" />
          <line x1="1.05" y1="18.95" x2="2.3" y2="17.7" stroke="black" />
          <line x1="-1.9" y1="14" x2="0" y2="14" stroke="black" />
          <line x1="-1.9" y1="10" x2="0" y2="10" stroke="black" />
          <line x1="1.05" y1="5.05" x2="2.3" y2="6.3" stroke="black" />

          <line x1="6" y1="12" x2="11" y2="7" stroke="red" strokeWidth="2" />

          <text x="21" y="23" fontFamily="Arial" fontSize="6" fill="black" textAnchor="middle">
            FPS
          </text>
        </svg>
      </FooterButton>
    </FooterButtonGroup>
  );
};
